import { newSlice,_fetchEntitiesService,_loadEvents,_createEntityService,_updateEntityService,_deleteEntityService} from "../../../redux/slices/common/sliceFunctions";

var entitiesName = 'States';

const entitiesSlice = newSlice(entitiesName);
const events = _loadEvents(entitiesSlice);

export const entitiesSelector = (state) => state[entitiesName];
export default entitiesSlice.reducer;

export function fetchEntitiesService(dataSlice) {
  dataSlice.dataUrl.code="GET_STATESBYWORKFLOW";
  return _fetchEntitiesService(dataSlice,events);
}

export function fetchAllStates(dataSlice) {
  dataSlice.dataUrl.code="GET_STATESBYMODEL";
  return _fetchEntitiesService(dataSlice,events);
}


export function createEntityService(dataSlice) {
  dataSlice.dataUrl.code="POST_STATES";
  return _createEntityService(dataSlice,events);
}

export function updateEntityService(dataSlice) {
  dataSlice.dataUrl.code="PUT_STATES";
  dataSlice.dataUpdate.isPost=true;
  return _updateEntityService(dataSlice,events);
}

export function deleteEntityService(dataSlice) {
  dataSlice.dataUrl.code="DELETE_STATES";
  return _deleteEntityService(dataSlice,events);
}